"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parsePath(path) {
    if (Array.isArray(path))
        return path;
    return path.split('.');
}
/*
 * Set the property at the given path without mutating the given object.
 *
 * @Param {object} obj             = The object to set a property on.
 * @Param {string | string[]} path = The path string or array to set the value
 *                                   at.
 * @Param {any} value              = The value to set.
 *
 * @Example
 *
 *     set({ food: 'salad' }, 'food', 'pizza')
 *     //=> { food: 'pizza' }
 *
 *     set({}, 'food', 'pizza')
 *     //=> { food: 'pizza' }
 *
 *     set({}, ['food', 'favorite'], 'pizza')
 *     //=> { food: { favorite: 'pizza' } }
 *
 *     set({}, 'food.favorite', 'pizza')
 *     //=> { food: { favorite: 'pizza' } }
 */
function set(obj, path, value) {
    const [key, ...additionalKeys] = parsePath(path);
    if (additionalKeys.length > 0) {
        const nextNode = Object.assign({}, set(obj[key], additionalKeys, value));
        return Object.assign({}, obj, { [key]: nextNode });
    }
    return Object.assign({}, obj, { [key]: value });
}
exports.set = set;
//# sourceMappingURL=set.js.map